"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedItems = void 0;
var FeedItems = function () {
  function FeedItems() {}
  FeedItems.getAttributeTypeMap = function () {
    return FeedItems.attributeTypeMap;
  };
  FeedItems.discriminator = undefined;
  FeedItems.attributeTypeMap = [{
    "name": "items",
    "baseName": "items",
    "type": "Array<FeedItem>"
  }];
  return FeedItems;
}();
exports.FeedItems = FeedItems;